export default "__VITE_ASSET__Dw4S3g1b__"